<section class="integrations-page" aria-label="Integrations">
    @if (detailRequested()) {
        <div class="detail-toolbar">
            <button mat-button type="button" (click)="backToList()"><mat-icon>arrow_back</mat-icon>Back to integrations</button>
            @if (!local && installationAvailable()) {
                <button mat-stroked-button type="button" (click)="repositoriesOpen.set(!repositoriesOpen())"
                        [attr.aria-expanded]="repositoriesOpen()" aria-controls="repository-management">Repositories and updates</button>
            }
        </div>
    } @else {
        <header class="page-heading">
            <div><h1 id="integrations-title">Integrations</h1><p>Configure and operate integrations for the selected account.</p></div>
            @if (!local && installationAvailable()) {
                <button mat-flat-button color="primary" type="button" (click)="repositoriesOpen.set(!repositoriesOpen())"
                        [attr.aria-expanded]="repositoriesOpen()" aria-controls="repository-management"><mat-icon>add</mat-icon>Add integration</button>
            }
        </header>
    }

    @if (!local && installationAvailable() && repositoriesOpen()) {
        <div id="repository-management"><app-connect-repositories (open)="selectInstalled($event)" /></div>
    }

    @if (detailRequested()) {
        @if (loading()) { <p class="page-state" role="status">Loading integration…</p> }
        @else if (error()) {
            <div class="page-state" role="alert"><p>{{ error() }}</p><button mat-stroked-button type="button" (click)="refresh()">Refresh integrations</button></div>
        } @else {
            @for (item of selected() ? [selected()!] : []; track item.id) {
                @if (view(item) === 'synthetic') { <app-connect-integrations [installationId]="item.id" /> }
                @else if (view(item) === 'health') { <app-scheduled-job-health [installationId]="item.id" /> }
                @else if (view(item) === 'coded') { <app-coded-integration-shell [installationId]="item.id" /> }
                @else { <div class="page-state" role="status"><h1>Management view unavailable</h1><p>This integration needs a supported view and runtime profile.</p></div> }
            } @empty {
                <div class="page-state" role="status"><h1>Integration unavailable</h1><p>Choose an integration from the selected account’s list.</p></div>
            }
        }
    } @else {
        <mat-card class="cardWithShadow integrations-card">
            <mat-card-content>
                <div class="filter-controls">
                    <mat-form-field appearance="outline" class="search-field"><mat-label>Search</mat-label>
                        <input matInput type="search" placeholder="Search integrations" [value]="search()" (input)="search.set($any($event.target).value)">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                    <button mat-stroked-button type="button" (click)="refresh()" [disabled]="loading()"><mat-icon>refresh</mat-icon>Refresh integrations</button>
                </div>
                @if (loading()) { <p class="list-state" role="status">Loading integrations…</p> }
                @else if (error()) { <p class="list-state" role="alert">{{ error() }}</p> }
                @else if (!installations().length) {
                    <div class="list-state" role="status"><mat-icon aria-hidden="true">extension</mat-icon><h2>No integrations installed</h2>
                        <p>No integrations are installed for the selected account.</p>
                        @if (!local && installationAvailable()) { <button mat-stroked-button type="button" (click)="repositoriesOpen.set(true)">Install from GitHub</button> }
                    </div>
                } @else {
                    <div class="table-responsive">
                        <table mat-table [dataSource]="filteredInstallations()" class="w-100" aria-label="Integrations">
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let item"><div class="name-cell-content">
                                    <span class="integration-icon" aria-hidden="true"><mat-icon>extension</mat-icon></span>
                                    <div class="listing-text"><span class="listing-title">{{ item.name }}</span>
                                        <span class="listing-description">{{ item.activeRevision ? 'Active settings ' + item.activeRevision : 'Not activated' }} · Draft {{ item.draftRevision }}</span>
                                    </div>
                                </div></td>
                            </ng-container>
                            <ng-container matColumnDef="version">
                                <th mat-header-cell *matHeaderCellDef>Version</th>
                                <td mat-cell *matCellDef="let item">{{ item.application?.packageVersion || '—' }}</td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let item"><span class="status-badge"
                                    [class.bg-light-success]="status(item) === 'Enabled'" [class.text-success]="status(item) === 'Enabled'"
                                    [class.bg-light-primary]="status(item) === 'Running'" [class.text-primary]="status(item) === 'Running'"
                                    [class.bg-light-warning]="status(item) === 'Needs attention'" [class.text-warning]="status(item) === 'Needs attention'"
                                    [class.neutral-badge]="status(item) === 'Paused' || status(item) === 'Needs setup'">{{ status(item) }}</span></td>
                            </ng-container>
                            <ng-container matColumnDef="runtime">
                                <th mat-header-cell *matHeaderCellDef>Runtime</th>
                                <td mat-cell *matCellDef="let item">{{ runtime(item) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>Actions</th>
                                <td mat-cell *matCellDef="let item"><button mat-icon-button type="button" (click)="select(item.id)"
                                    [attr.aria-label]="'Open ' + item.name" matTooltip="Open integration"><i-tabler name="edit" /></button></td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="columns"></tr>
                            <tr mat-row *matRowDef="let row; columns: columns"></tr>
                            <tr class="mat-row" *matNoDataRow><td class="no-results" [attr.colspan]="columns.length" role="status">No integrations match your search.</td></tr>
                        </table>
                    </div>
                }
            </mat-card-content>
        </mat-card>
    }
</section>
